import request from '../utils/request';

/**
 * Thin wrapper around /api/v1/admin/concierge-services for the admin app.
 *
 * Admin-only — requires an adminUser token. Used by the
 * ConciergeServicesAdminScreen to manage per-service discounts,
 * sort order, activation, etc.
 */
export const ConciergeServiceService = {
  list: async () => {
    const response = await request.get('/admin/concierge-services');
    return response.data;
  },

  create: async (payload) => {
    const response = await request.post('/admin/concierge-services', payload);
    return response.data;
  },

  update: async (id, payload) => {
    const response = await request.put(`/admin/concierge-services/${id}`, payload);
    return response.data;
  },

  remove: async (id) => {
    const response = await request.delete(`/admin/concierge-services/${id}`);
    return response.data;
  },

  reorder: async (items) => {
    const response = await request.patch('/admin/concierge-services/reorder', { items });
    return response.data;
  },
};

export default ConciergeServiceService;
